const selectors = {
  wrapper: '[data-swapper-wrapper]',
  target: '[data-swapper-target]',
  hover: 'data-swapper-hover',
};

let sections = {};

class Swapper {
  constructor(el) {
    this.container = el;
    this.target = this.container.querySelector(selectors.target);
    this.hovers = this.container.querySelectorAll(`[${selectors.hover}]`);

    if (this.target && this.hovers.length) {
      this.deafaultContent = this.target.innerHTML;
      this.init();
    }
  }

  init() {
    this.hovers.forEach((hover) => {
      hover.addEventListener(
        'mouseenter',
        function () {
          const newContent = hover.getAttribute(selectors.hover);
          this.target.innerHTML = `${newContent}`;
        }.bind(this)
      );
    });
    this.hovers.forEach((hover) => {
      hover.addEventListener(
        'mouseleave',
        function () {
          this.target.innerHTML = this.deafaultContent;
        }.bind(this)
      );
    });
    this.hovers.forEach((hover) => {
      hover.addEventListener(
        'click',
        function () {
          const clickedContent = hover.getAttribute(selectors.hover);
          this.deafaultContent = `${clickedContent}`;
        }.bind(this)
      );
    });
  }
}

function makeSwappers(container) {
  sections[container.id] = [];
  const els = container.querySelectorAll(selectors.wrapper);
  els.forEach((el) => {
    sections[container.id].push(new Swapper(el));
  });
}

const swapperSection = {
  onLoad() {
    makeSwappers(this.container);
  },
};

export {swapperSection, Swapper, makeSwappers};
